
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eligibility",
      function () {
        return require("private-next-pages/eligibility.js");
      }
    ]);
  